import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { Schema_Beschaeftigung } from 'cpool-schemas';

const getDefaultPensioner = (): {
    beschaeftigung: Extract<Schema_Beschaeftigung, { beschaeftigungsart: typeof EMPLOYMENT_TYPES.RENTNER }>;
} => ({
    beschaeftigung: {
        beschaeftigungsart: EMPLOYMENT_TYPES.RENTNER,
        rentner: {
            rentenversicherung: {
                anschrift: {
                    hausnummer: null,
                    land: null,
                    ort: null,
                    plz: null,
                    strasse: null,
                },
                name: null,
            },
            rentnerSeit: null,
            staatlicheRenteMonatlich: null,
        },
        steuerklasse: null,
    },
});
export default getDefaultPensioner;
